module.exports = __webpack_public_path__ + "static/img/posco-safety-consulting.e9ce5a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/posco-safety-consulting.jpg
// module id = jx8L
// module chunks = 0